import { ringover, ringoverNew, aida } from './keys';
import notifSystem from '../notifSystem';

const detectExtension = (extensionId) => new Promise(
  (resolve) => {
    let img = null;
    img = new Image();
    img.src = extensionId === aida
      ? `chrome-extension://${extensionId}/icons/aida-owl-icon.svg`
      : `chrome-extension://${extensionId}/assets/img/lesbonsartisansdef.png`;
    img.onload = function() {
      return resolve(true);
    };
    img.onerror = function() {
      return resolve(false);
    };
  }
);

export const call = async number => {
  let extensionId = ringoverNew;
  let hasExtension = await detectExtension(extensionId);
  if (!hasExtension) {
    extensionId = ringover;
    hasExtension = await detectExtension(extensionId);
  }
  if (hasExtension) {
    if ((window.chrome || {}).runtime) {
      return window.chrome.runtime.sendMessage(extensionId, {
        tel: number,
      });
    }
  } else {
    if (!localStorage.getItem('firstCall')) {
      localStorage.setItem('firstCall', true);
      return window.open(`callto:${number}`);
    }
    const popUp = window.open(
      `callto:${number}`,
      'callTo',
      'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,' +
        `left=${screen.width * 2}, top=10000, width=10, height=10, visible=none`
    );
    if (popUp) {
      popUp.document
        .write('<script>setTimeout(() => window.close(), 500)</script>');
    } else {
      notifSystem.error('Message', 'Action appel erreur');
    }
  }
  return false;
};

// Pilote l'agent IA actif côté extension (ouvre le sidepanel si agentId fourni,
// le ferme/désactive l'analyse si agentId est null).
export const setAidaAgent = async (agentId) => {
  try {
    const hasExtension = await detectExtension(aida);
    if (hasExtension && (window.chrome || {}).runtime) {
      window.chrome.runtime.sendMessage(aida, {
        type: 'setAgent',
        agentId
      });
      window.chrome.runtime.sendMessage(aida, {
        type: agentId ? 'openSidepanel' : 'closeSidepanel'
      });
    }
  } catch (error) {
    console.error('Error setting Aida agent:', error);
  }
};

export const getClientNumbers = (elem, field = 'client') => {
  if (elem.billing) {
    field = ['client', 'billing'];
    return field.map(elemField => ['tel1', 'tel2', 'tel3']
      .filter(e => elem[elemField][e])
      .map(tel => elem[elemField][tel]));
  }
  return ['tel1', 'tel2', 'tel3']
    .filter(e => elem[field][e])
    .map(tel => elem[field][tel]);
};
